export function findRepoId() {
    return document.querySelector('.current-repository-id').textContent
}